// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CollectionPage_wrapper__fVoVf","spinner":"CollectionPage_spinner__vKPEx","breadcrumbs":"CollectionPage_breadcrumbs__5yzWm"};